/**
 * EVC (Euler Vault Connector) Integration
 * 
 * This module provides integration with Euler's EVC system for:
 * - Native asset wrapping/unwrapping (HYPE ↔ WHYPE)
 * - Batch transactions via EVC
 * - Transaction simulation with debug tracing
 * - Leverage/multiply positions
 * 
 * Uses wagmi-evc's full stack for proper transaction handling.
 */

// Main hook for EVC batch transactions
export {
  useEvcBatchTransaction,
  getSubAccount,
  getSubAccountId,
  TransactionLabel,
  type EvcBatchTransactionParams,
  type EvcBatchTransactionResult,
  type TransactionItems,
  type DepositTransactionItem,
  type BorrowTransactionItem,
  type SkimTransactionItem,
  type WrapTransactionItem,
  type UnwrapTransactionItem,
  type WithdrawTransactionItem,
  type RepayTransactionItem,
  type LeverageTransactionItem,
  type TransferTransactionItem,
  type Asset,
} from './useEvcBatchTransaction'

// Transaction factory utilities (for manual batch construction if needed)
export {
  createEvcBatchConfig,
  createNativeDepositBatchConfig,
  createNativeWithdrawBatchConfig,
  createEvcWrapTransactionItem,
  createEvcUnwrapTransactionItem,
  type EvcNativeDepositParams,
  type EvcNativeWithdrawParams,
} from './transactionFactory'
